module.exports = __webpack_public_path__ + "img/worksbot_img19121101.4f8436e7.jpg";